import { Col, Row } from 'antd';
import { OwnerType, UserRole } from 'gql/types';
import { FormItem } from 'modules/common/components';
import { getPersonalInfoFields } from 'modules/owner/components/EditProfileForm/fields';
import { EditProfileFormSchemaType } from 'modules/owner/components/EditProfileForm/schema';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC, useMemo } from 'react';
import { Path, useFormContext } from 'react-hook-form';

import { PersonalInfoFields } from '../enum';

type PropTypes = {
  disabled?: boolean;
};

const PersonalInfoFormSection: FC<PropTypes> = ({ disabled }) => {
  const { control, formState, getFieldState } =
    useFormContext<EditProfileFormSchemaType>();
  const currentUser = useCurrentUser();
  const isIndividualOwner = currentUser?.data?.type === OwnerType.Individual;
  const isOwner = currentUser.data?.role.value === UserRole.Owner;

  const personalInfoFields = useMemo(() => getPersonalInfoFields(), []);

  const isFieldDisabled = (field: PersonalInfoFields) =>
    disabled ||
    (isIndividualOwner &&
      field === PersonalInfoFields.locationPreferences &&
      isOwner);

  return (
    <Col span={24}>
      {personalInfoFields.map(({ name, Component, label }) => {
        const fieldName =
          `personalInfo.${name}` as Path<EditProfileFormSchemaType>;
        const { error } = getFieldState(fieldName, formState);

        return (
          <Row key={fieldName}>
            <Col span={24}>
              <FormItem
                label={label}
                extra={error?.message}
                validateStatus={error ? 'error' : undefined}
              >
                <Component
                  control={control}
                  name={fieldName}
                  disabled={isFieldDisabled(name)}
                />
              </FormItem>
            </Col>
          </Row>
        );
      })}
    </Col>
  );
};

export default PersonalInfoFormSection;
